import { FlexStack } from '~/components/atomic';
import {
  GroupChatCard,
  TypeButtonSkeleton,
} from '~/components/atomic/Skeleton';
import { makeIndexArray } from '~/utils';

export default function SearchRoomSkeleton() {
  return (
    <FlexStack>
      <FlexStack direction='row'>
        {makeIndexArray(3).map((el) => (
          <TypeButtonSkeleton key={el} />
        ))}
      </FlexStack>

      {makeIndexArray(6).map((el) => (
        <GroupChatCard key={el} />
      ))}
    </FlexStack>
  );
}
